import styled from 'styled-components';

interface MobileDrawerOverlayProps {
  $isOpen: boolean;
  $breakpoint?: number;
  $zIndex?: number;
}

interface MobileDrawerNavProps {
  $isOpen: boolean;
  $breakpoint?: number;
  $zIndex?: number;
  $width?: string;
  $padding?: string;
}

interface MobileDrawerCloseButtonProps {
  $isOpen: boolean;
  $breakpoint?: number;
  $zIndex?: number;
}

export const MobileDrawerOverlay = styled.div<MobileDrawerOverlayProps>`
  display: none;

  @media (max-width: ${(props) => props.$breakpoint ?? 1024}px) {
    background: var(--white);
    bottom: 0;
    display: block;
    left: 0;
    opacity: ${(props) => (props.$isOpen ? '0.9' : '0')};
    pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 0.3s ease-in-out;
    z-index: ${(props) => props.$zIndex ?? 998};
  }
`;

export const MobileDrawerNav = styled.nav<MobileDrawerNavProps>`
  display: none;

  @media (max-width: ${(props) => props.$breakpoint ?? 1024}px) {
    background: var(--white);
    box-shadow: 2px 0 10px var(--black-tint-500);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100vh;
    left: 0;
    overflow-y: auto;
    padding: ${(props) => props.$padding ?? '10px 30px'};
    position: fixed;
    top: 0;
    transform: ${(props) =>
      props.$isOpen ? 'translateX(0)' : 'translateX(-100%)'};
    transition: transform 0.3s ease-in-out;
    width: ${(props) => props.$width ?? '280px'};
    z-index: ${(props) => props.$zIndex ?? 999};
  }
`;

export const MobileDrawerCloseButton = styled.button<MobileDrawerCloseButtonProps>`
  align-items: center;
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 50%;
  box-shadow: var(--shadow-md);
  color: var(--grey-900);
  cursor: pointer;
  display: none;
  font-size: 20px;
  height: 40px;
  justify-content: center;
  opacity: ${(props) => (props.$isOpen ? '1' : '0')};
  pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};
  position: fixed;
  right: 20px;
  top: 20px;
  transition:
    opacity 0.3s ease-in-out,
    color 0.2s;
  width: 40px;
  z-index: ${(props) => props.$zIndex ?? 1000};

  &:hover {
    color: var(--wbs-red);
  }

  @media (max-width: ${(props) => props.$breakpoint ?? 1024}px) {
    display: flex;
  }
`;
